var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zjly-web-about"},[_c('banner-nav',{attrs:{"datas":_vm.bannerList,"height":300}}),_c('page-nav-bar',{attrs:{"datas":_vm.menuList,"defaultId":_vm.defaultId},on:{"select":_vm.navBarClick}}),_c('div',{staticClass:"zjly-web-about-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }